import Loader from 'components/ui/Loader';
import useLogin from 'hooks/use-login';
import { useLocalStorage } from 'hooks/useLocalStorage';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Outlet as WidgetOutlet } from 'react-router-dom';
import { eventTrackingHandler, gaEventTracking, trackingConstant } from 'utils/analytics';
import {
  getCurrentRoute,
  generateUniqueId,
  getParentLoginCookie,
  getGameLoginCookie,
  deleteAllLoginCookies,
  getGuestUserInfoFromLocalStorage,
  isTopicalQuiz
} from 'utils/commonFunctions';
import { GUEST_USER_INFO, WISDEN_QUIZ_USER_ID } from 'utils/constants';

function Outlet() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useLocalStorage(WISDEN_QUIZ_USER_ID);
  const { performLogin, isLoading, isError } = useLogin(); // Use the custom hook
  const [shouldRenderOutlet, setShouldRenderOutlet] = useState(false);

  useEffect(() => {
    if (!value) setValue(generateUniqueId());
    if (value && value > 0) {
      setValue(-value);
    }

    document.addEventListener('click', eventTrackingHandler);
    return () => {
      document.removeEventListener('click', eventTrackingHandler);
    };
  }, [value, setValue]);

  useEffect(() => {
    const constants = {
      '': trackingConstant.HOME_SCREEN_LOADED,
      rules: trackingConstant.RULES_SCREEN_LOADED,
      result: trackingConstant.RESULT_SCREEN_LOADED
    };

    gaEventTracking(constants[getCurrentRoute(pathname)]);
  }, [pathname]);

  useEffect(() => {
    const checkLoginStatus = async () => {
      // const token = localStorage.getItem(LOGIN_TOKEN);

      // if (isUserLoggedIn() || !token) {
      //   setShouldRenderOutlet(true);
      // } else {
      //   try {
      //     await performLogin();
      //   } catch (error) {
      //     console.error('Login failed:', error);
      //   } finally {
      //     setShouldRenderOutlet(true);
      //   }
      // }

      const parentCookie = JSON.parse(getParentLoginCookie());
      const gameCookie = JSON.parse(getGameLoginCookie());

      const login = async () => {
        try {
          await performLogin();
          const guestUserInfo = getGuestUserInfoFromLocalStorage();
          // if (guestUserInfo?.hasPlayed && !guestUserInfo?.hasPointsMerged) {
          if (guestUserInfo?.hasPlayed) {
            localStorage.setItem(
              GUEST_USER_INFO,
              // JSON.stringify({ ...guestUserInfo, hasPointsMerged: true })
              JSON.stringify({
                ...guestUserInfo,
                hasPointsMerged: [...guestUserInfo?.hasPlayed]
              })
            );
          }
        } catch (error) {
          console.error('Login failed:', error);
        } finally {
          setShouldRenderOutlet(true);
        }
      };

      if (parentCookie && gameCookie) {
        if (
          parentCookie?.waf_user_guid !== gameCookie?.WAF_GUID ||
          parentCookie?.first_name !== gameCookie?.FirstName ||
          parentCookie?.last_name !== gameCookie?.LastName
        ) {
          await login();
        } else {
          setShouldRenderOutlet(true);
        }
      } else if (!gameCookie && parentCookie) {
        await login();
      } else if (gameCookie && !parentCookie) {
        deleteAllLoginCookies();
        setShouldRenderOutlet(true);
      } else {
        setShouldRenderOutlet(true);
      }
    };

    checkLoginStatus();
  }, [performLogin]);

  if (isLoading || !shouldRenderOutlet) {
    return <Loader />;
  }

  return (
    <div
      className={`si-main-component si-quiz--wisden ${isTopicalQuiz() ? 'si-quiz--topical' : ''}`}
    >
      <WidgetOutlet />
    </div>
  );
}

export default Outlet;
